import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CryptotokenSlotsActions,
  CryptotokenSlotsPipes,
  CryptotokenSlotsSelectors,
} from './cryptotoken-slots.feature';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CryptotokenSlotsService {
  private store = inject(Store);

  cryptotokenSlots$: Observable<string[]> = this.store.pipe(
    CryptotokenSlotsPipes.selectData,
  );

  areCryptotokenSlotsLoading$: Observable<boolean> = this.store.select(
    CryptotokenSlotsSelectors.selectIsLoading,
  );

  ensureCryptotokenSlots(options?: { suppressErrorNotification?: boolean }) {
    this.store.dispatch(
      CryptotokenSlotsActions.ensure({
        suppressErrorNotification: options?.suppressErrorNotification,
      }),
    );
  }
}
